import { canv } from "@/canv/global.js";
import { getTarget } from "@/canv/utils.js";
import type { widgetOption } from "@/widgetMenu/widgetMenu";
import { wmBase } from "@/widgetMenu/wmBase";

type Align = "left" | "center" | "right";

export class WmTextAlign extends wmBase {
    constructor(options: widgetOption<string>[]) {
        super();
        this.options = options;
    }

    build() {
        const selectedAligns = this.options.map((option) => option.value);
        const uniqueAligns = [...new Set(selectedAligns)];
        const firstAlign = uniqueAligns[0];

        const align: Align = ["left", "center", "right"].includes(firstAlign)
            ? (firstAlign as Align)
            : "left";

        return `
            <div class="wm_textAlign">
                ${this.alignData[align]}
            </div>
            <div class="wm_dividor"></div>
        `;
    }

    init() {
        const item = document.querySelector<HTMLElement>(".wm_textAlign");
        item?.removeEventListener("click", this.showSubMenu);
        item?.addEventListener("click", this.showSubMenu);
    }

    private showSubMenu = (e: MouseEvent) => {
        const subm = document.querySelector<HTMLElement>(".wm_textAlign_submenu");
        if (subm) {
            subm.remove();
            return;
        }

        const otherSubm = document.querySelector<HTMLElement>(".widgetSubMenu");
        otherSubm?.remove();

        canv.widgetMenu.subMenuBoss = this.name;

        const submenu = document.createElement("div");
        submenu.classList.add("widgetSubMenu", "wm_textAlign_submenu");
        submenu.style.opacity = "0";
        document.body.prepend(submenu);

        (["left", "center", "right"] as Align[]).forEach((type) => {
            submenu.innerHTML += this.submenuTemplate(this.alignData[type], type);
        });

        submenu.querySelectorAll<HTMLElement>(".wm_textAlign_submenu_item").forEach((item) => {
            item.removeEventListener("click", this.itemClick);
            item.addEventListener("click", this.itemClick);
        });

        setTimeout(() => canv.widgetMenu.TryLocateMenu(), 50);
    };

    private itemClick = (e: MouseEvent) => {
        const item = getTarget(e, "wm_textAlign_submenu_item");
        const align = item.getAttribute("alignType") as Align | null;
        if (!align) return;

        this.applyValue(this.options, align);

        const menuItem = document.querySelector<HTMLElement>(".wm_textAlign");
        if (menuItem) {
            menuItem.innerHTML = this.alignData[align];
        }
    };

    private submenuTemplate(view: string, type: Align) {
        return `
            <div class="wm_textAlign_submenu_item" alignType="${type}">
                ${view}
            </div>
        `;
    }

    alignData: Record<Align, string> = {
        left: `
            <svg width="23" height="23" viewBox="0 0 100 72" xmlns="http://www.w3.org/2000/svg">
                <line x1="4" y1="4" x2="96" y2="4" stroke="black" stroke-width="8" stroke-linecap="round"/>
                <line x1="4" y1="35" x2="56" y2="35" stroke="black" stroke-width="8" stroke-linecap="round"/>
                <line x1="4" y1="68" x2="71" y2="68" stroke="black" stroke-width="8" stroke-linecap="round"/>
            </svg>
        `,
        center: `
            <svg width="23" height="23" viewBox="0 0 100 72" xmlns="http://www.w3.org/2000/svg">
                <line x1="4" y1="4" x2="96" y2="4" stroke="black" stroke-width="8" stroke-linecap="round"/>
                <line x1="24" y1="35" x2="76" y2="35" stroke="black" stroke-width="8" stroke-linecap="round"/>
                <line x1="17" y1="68" x2="84" y2="68" stroke="black" stroke-width="8" stroke-linecap="round"/>
            </svg>
        `,
        right: `
            <svg width="23" height="23" viewBox="0 0 100 72" xmlns="http://www.w3.org/2000/svg">
                <line x1="4" y1="4" x2="96" y2="4" stroke="black" stroke-width="8" stroke-linecap="round"/>
                <line x1="44" y1="35" x2="96" y2="35" stroke="black" stroke-width="8" stroke-linecap="round"/>
                <line x1="29" y1="68" x2="96" y2="68" stroke="black" stroke-width="8" stroke-linecap="round"/>
            </svg>
        `,
    };
    name = "wm_textAlign";
    options: widgetOption<string>[] = [];
    isStriked = false;
}
